const STEPS = [
  {
    title: 'Add a provider',
    description: 'Set up your first team member’s profile.',
  },
  {
    title: 'Set availability',
    description: 'Create availability slots for booking.',
  },
  {
    title: 'Publish a booking type',
    description: 'Define the service your clients will book.',
  },
  {
    title: 'Take your first booking',
    description: 'Once booked, sessions appear right here.',
  },
];

export function GettingStarted() {
  return (
    <div className="bg-paper-hi rounded-lg shadow-card overflow-hidden">
      <div className="px-5 py-5">
        <h2 className="text-[15px] font-semibold">Welcome to your dashboard</h2>
        <p className="text-[12.5px] text-ink-4 mt-1">
          Complete these steps to start seeing data here.
        </p>
      </div>

      <div className="divide-hair">
        {STEPS.map((step) => (
          <div key={step.title} className="px-5 py-4 flex items-start gap-3">
            <div className="mt-0.5 w-4 h-4 rounded border border-ink-5 shrink-0" />
            <div>
              <div className="text-[13px] font-medium">{step.title}</div>
              <div className="text-[12px] text-ink-4 mt-0.5">{step.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
